import { __assign, __read, __rest } from "tslib";
/* eslint-disable dot-notation */
import React, { useCallback, useLayoutEffect, useRef, useState } from "react";
import classNames from "classnames";
import { useDefaultValue } from "../form/controlled";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { useConfig } from "../_util/config-context";
import { noop } from "../_util/noop";
import { KeyMap } from "../_util/key-map";
import { mergeRefs } from "../_util/merge-refs";
import calcTextareaHeight from "./calcTextAreaHeight";
var DEFAULT_TEXTAREA_STYLE = { height: "auto", minHeight: "auto" };
export var TextArea = forwardRefWithStatics(function (props, ref) {
    var _a;
    var classPrefix = useConfig().classPrefix;
    var _b = useDefaultValue(props, ""), placeholder = _b.placeholder, disabled = _b.disabled, readonly = _b.readonly, size = _b.size, className = _b.className, style = _b.style, value = _b.value, onChange = _b.onChange, showCount = _b.showCount, _c = _b.autoSize, autoSize = _c === void 0 ? false : _c, _d = _b.onCompositionStart, onCompositionStart = _d === void 0 ? noop : _d, _e = _b.onCompositionEnd, onCompositionEnd = _e === void 0 ? noop : _e, _f = _b.onKeyPress, onKeyPress = _f === void 0 ? noop : _f, _g = _b.onPressEnter, onPressEnter = _g === void 0 ? noop : _g, restProps = __rest(_b, ["placeholder", "disabled", "readonly", "size", "className", "style", "value", "onChange", "showCount", "autoSize", "onCompositionStart", "onCompositionEnd", "onKeyPress", "onPressEnter"]);
    var composingRef = useRef(false);
    // 记录 `composition` 事件过程中值以实现受控
    var _h = __read(useState(""), 2), composingRefValue = _h[0], setComposingValue = _h[1];
    var _j = __read(useState(DEFAULT_TEXTAREA_STYLE), 2), textareaStyle = _j[0], setTextareaStyle = _j[1];
    var textareaRef = useRef(null);
    var inputClassName = classNames(classPrefix + "-textarea  " + classPrefix + "-custom-scrollbar-visiable ", (_a = {},
        _a[className] = className,
        _a["size-" + (size === "full" ? size + "-width" : size)] = size,
        _a));
    var adjustTextareaHeight = useCallback(function () {
        if (autoSize === true) {
            return calcTextareaHeight(textareaRef.current);
        }
        if (typeof autoSize === "object") {
            return calcTextareaHeight(textareaRef.current, autoSize === null || autoSize === void 0 ? void 0 : autoSize.minRows, autoSize === null || autoSize === void 0 ? void 0 : autoSize.maxRows);
        }
        return DEFAULT_TEXTAREA_STYLE;
    }, [autoSize]);
    // useLayoutEffect(() => {
    //   if (autoSize) {
    //     setResizeState(RESIZE_START);
    //   }
    // }, [value, autoSize]);
    useLayoutEffect(function () {
        setTextareaStyle(adjustTextareaHeight());
    }, [adjustTextareaHeight, value]);
    var hasRows = restProps.rows;
    var inputProps = __assign({ placeholder: placeholder, className: inputClassName, readOnly: readonly, disabled: disabled, 
        // 受样式限制 rows 属性没有生效
        style: (function () {
            if (autoSize) {
                return __assign(__assign({}, textareaStyle), style);
            }
            if (hasRows) {
                return __assign({ height: "auto" }, (style || {}));
            }
            return style;
        })(), value: composingRef.current ? composingRefValue : value, onChange: function (event) {
            if (composingRef.current) {
                if (autoSize) {
                    onChange(event.target.value, { event: event });
                }
                setComposingValue(event.target.value);
            }
            else {
                onChange(event.target.value, { event: event });
            }
        }, onCompositionStart: function (event) {
            composingRef.current = true;
            setComposingValue(event.currentTarget.value);
            onCompositionStart(event);
        }, onCompositionEnd: function (event) {
            if (composingRef.current) {
                composingRef.current = false;
                onChange(event.currentTarget.value, { event: event });
            }
            setComposingValue("");
            onCompositionEnd(event);
        }, onKeyPress: function (event) {
            if (event.key === KeyMap.Enter) {
                onPressEnter(event.currentTarget.value, event);
            }
            onKeyPress(event);
        } }, restProps);
    var component = (React.createElement("textarea", __assign({ ref: mergeRefs(textareaRef, ref) }, inputProps)));
    if (showCount) {
        var max = inputProps.maxLength;
        var len = value ? String(value).length : 0;
        return (React.createElement("div", { className: classPrefix + "-textarea-group " + (disabled || readonly ? "is-disabled" : ""), style: size === "full" ? { width: "100%" } : undefined },
            component,
            React.createElement("label", { className: classPrefix + "-textarea__label" }, max ? len + " / " + max : len)));
    }
    return component;
}, {
    /**
     * 在表单布局中，和 label 的默认对齐方式
     */
    defaultLabelAlign: "middle",
});
TextArea.displayName = "TextArea";
//# sourceMappingURL=TextArea.js.map